import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "formula-settings container-page" }
const _hoisted_2 = {
  key: 0,
  class: "formula-settings__body"
}
const _hoisted_3 = {
  key: 0,
  class: "invalid-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComponentInput = _resolveComponent("ComponentInput")!
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "title-inner" }, "Формула расчета рейтинга активности", -1)),
    (_ctx.isAccessAllowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_InputBlock, {
            class: "formula-settings__field error-position-absolute",
            title: "Формула расчета",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ComponentInput, {
                modelValue: _ctx.formula,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formula) = $event)),
                mod: "rectangular",
                placeholder: "Например: 0,5*A+B+C+2*D",
                maxLength: _ctx.formulaMaxLength,
                error: !!_ctx.errorMessage,
                disabled: _ctx.isLoading || !_ctx.canEdit
              }, null, 8, ["modelValue", "maxLength", "error", "disabled"]),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_ButtonComponent, {
            mod: "gradient-bg",
            disabled: _ctx.isSaveDisabled,
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isSaving ? 'Сохранение...' : 'Сохранить'), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])), [
            [_directive_permission, _ctx.permissions.edit]
          ]),
          _cache[1] || (_cache[1] = _createStaticVNode("<section class=\"formula-settings__rules\" data-v-648a2567><h2 class=\"formula-settings__rules-title\" data-v-648a2567>Правила написания формулы</h2><p class=\"formula-settings__rules-subtitle\" data-v-648a2567>Параметры формулы:</p><ul class=\"formula-settings__rules-list\" data-v-648a2567><li data-v-648a2567><b data-v-648a2567>A</b> — количество мероприятий;</li><li data-v-648a2567><b data-v-648a2567>B</b> — количество значимых мероприятий;</li><li data-v-648a2567><b data-v-648a2567>C</b> — количество соглашений без стоимостной оценки;</li><li data-v-648a2567><b data-v-648a2567>D</b> — количество соглашений со стоимостной оценкой.</li></ul><p class=\"formula-settings__rules-subtitle\" data-v-648a2567>Как редактировать формулу:</p><ul class=\"formula-settings__rules-list\" data-v-648a2567><li data-v-648a2567>коэффициент указывается перед параметром через знак умножения (например, 0,5*A, 2*D);</li><li data-v-648a2567>между параметрами допустимы математические знаки: *, /, +, −;</li><li data-v-648a2567>параметры можно исключать из формулы и добавлять обратно;</li><li data-v-648a2567>набор параметров ограничен (A, B, C, D);</li><li data-v-648a2567>один и тот же параметр не может повторяться.</li></ul></section>", 1))
        ]))
      : _createCommentVNode("", true)
  ]))
}